<template>
  <nav>
    <ol class="navigation-list" ref="list" :style="getPixelTransform">
      <li
        v-for="(item, index) in menuItems"
        :key="'menu-item-' + index"
        class="navigation-item"
        :style="getAppStyles(item, isActive && activeItemIndex === index)"
        :class="{
          'navigation-item--active': isActive && activeItemIndex === index,
        //  'navigation-item--active': isActive && item.imgUrl,
        }"
        ref="listItems"
      >
        <div class="navigation-item__title">
          {{ getLang(item.lang).title }}
        </div>
      </li>
    </ol>
    <!--<div id="custom" style="position: absolute; top: 200px; left: 100px; background-color: brown; border: 5px solid gray; padding: 2em; display: flex;">{{ getCustomLang() }}</div>-->
  </nav>
</template>

<script>
import { getLang } from '@/plugin/LangControl';
//import DeviceType from '../helpers/DeviceType';
import Device from '../helpers/Device';

export default {
  props: {
    menuItems: Array,
    activeItemIndex: Number,
    isActive: Boolean,
  },
  emits: {},
  data() {
    return {
      scrollPositionCounter: 0,
      visibleElements: 0,
      wrapperSize: 0,
      itemSize: 0,
      scrollOffset: 3,
      pixelOffset: 5,
      pixelTransform: 0,
      getLang,
    };
  },
  mounted() {
    const pixelOffset = (window.innerWidth / 100) * this.pixelOffset;
    this.pixelOffset = pixelOffset;
    this.handleScrolling(this.activeItemIndex);
  },
  watch: {
    activeItemIndex(index) {
      this.handleScrolling(index);
    },
  },
  methods: {
    getAppStyles(item, isActive) {
      const colorStyles = this.$store.getters['customizer/getAppStyles'](
        isActive
      );
      const baseUrl = item.thumbnailUrl.length > 0 ? item.thumbnailUrl : "";

      return {
        ...colorStyles,
        backgroundImage: `url(${baseUrl})`,
        backgroundSize: 'cover',
      };
    },
    getSVGAppStyle(item, isActive) {
      const colorStyles = this.$store.getters['customizer/getAppSVGStyle'];

      return {
        ...colorStyles,
      };
    },
    getCustomLang(item) {
      //const languages = this.$store.getters['customizer/getLanguage'];

      //const device = this.$store.getters['vod/get']();
      //const device = this.$store.state.device;
      console.log("***************************************************PROPS", this.menuItems);
      const device = this.menuItems;
      return {
        device,
        //...languages,
        //resolution,
        //version,
        //backgroundImage: `url(${baseUrl + item.imgUrl})`,
      };
      
    },
    handleScrolling(index) {
      if (this.$refs.listItems) {
        const itemNode = this.$refs.listItems[index];
        const spacingLeft = itemNode.getBoundingClientRect().x || itemNode.getBoundingClientRect().left;
        const spacingRight =
          window.innerWidth - (spacingLeft + itemNode.offsetWidth);
        if (spacingRight < this.pixelOffset) {
          this.pixelTransform += spacingRight - this.pixelOffset;
        } else if (spacingLeft < this.pixelOffset) {
          this.pixelTransform -= spacingLeft - this.pixelOffset;
        }
      }
    },
  },
  computed: {
    getPixelTransform() {
      return {
        transform: `translateX(${this.pixelTransform}px)`,
      };
    },
  },
};
</script>

<style scoped>
.navigation-list {
  display: flex;
  justify-content: start;
  transition: transform 0.5s ease;
}

.navigation-item {
  /*aspect-ratio: 1/2;*/
  box-sizing: border-box;
  color: #f1f1f1;
  font-weight: bold;
  font-size: 3vh;
  display: block;
  height: 20vh;
  border-width: 0px;/* TODO: customizer */
  border-style: solid;
  background-position: center;
  background-repeat: no-repeat;
  /*background: border-box;*/
  background-size: cover;
  flex: 0 0 30.5vh;
  margin-right: 1rem;
  text-align: center;
  width: 30.5vh;
}

/*
.navigation-item--active {
  box-sizing: border-box;
  color: #f1f1f1;
  font-weight: bold;
  font-size: 3vh;
  display: block;
  height: 20vh;
  border-width: 5px;
  border-style: solid;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  flex: 0 0 30vh;
  margin-right: 1rem;
  text-align: center;
  width: 30vh;
}
*/

.navigation-item__title {
  line-height: 100%;
  padding-top: 2%;
  height: 4vh;
  width: 100%;
  overflow: hidden;
  backdrop-filter: blur(20px);
}
</style>



// WEBPACK FOOTER //
// src/components/Vod.vue